import { Toast } from "components/commons";
import { LayoutA } from "components/layouts";
import { StaffContext } from "contexts";
import React, { useContext } from "react";
import { getCurrentUrl, prettifyStaffRole } from "services";
import lang from "translations";
import styles from "./go-to-app-page.module.scss";
import { useMount } from "hooks";

const SUPPORT_EMAIL = "support@socashless.com";

const LockEmblem = () => (
  <div className={styles.emblem} aria-hidden="true">
    <svg
      width="40"
      height="40"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#008D91"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="5" y="11" width="14" height="10" rx="2.5"></rect>
      <path d="M8 11V7.8a4 4 0 0 1 8 0V11"></path>
      <circle cx="12" cy="15.4" r="1.35" fill="#008D91" stroke="none"></circle>
      <path d="M12 16.6v1.8"></path>
    </svg>
  </div>
);

const CheckBadge = () => (
  <span className={styles.check} aria-hidden="true">
    <svg
      width="12"
      height="12"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#fff"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M5 12.5l4.5 4.5L19 7"></path>
    </svg>
  </span>
);

const GoToAppPage = () => {
  const { staff } = useContext(StaffContext);

  useMount(() => {
    const currentUrl = getCurrentUrl();
    if (currentUrl.includes("inventory/stocktake/")) {
      Toast({
        content: lang.youDontHavePermission,
        error: true,
      }).open();
    }
  });

  return (
    <LayoutA>
      <div className={styles.stage}>
        <div className={styles.card} role="region" aria-label={lang.noDashboardAccess}>
          <LockEmblem />

          <h1 className={styles.title}>
            {staff.firstName ? lang.populate(lang.hiName, [staff.firstName]) : lang.hello}
          </h1>
          <p className={styles.lede}>{lang.noDashboardAccess}</p>

          <div className={styles.divider}></div>

          <p className={styles.rolesLabel}>{lang.yourCurrentAssignedRoles}</p>
          {staff.roles.map((role, index) => (
            <div key={index} className={styles.roleRow}>
              <CheckBadge />
              {prettifyStaffRole(role)}
            </div>
          ))}

          <div className={styles.help}>
            <p>{lang.askYourAdminToUpdateAccess}</p>
            <p>
              <lang.Translate
                text={lang.needAdditionalSupportContact}
                items={[<a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>]}
              />
            </p>
          </div>
        </div>
      </div>
    </LayoutA>
  );
};

export default GoToAppPage;
